import * as Cmp from "@impero-com/common/utils/comparison";

import { UserTagCategoryOverview } from "api/generated/model";

export function getActiveCategoryNames(
    tagCategories: UserTagCategoryOverview[]
): string[] {
    return tagCategories
        .filter((category) => category.active)
        .map((category) => category.name)
        .sort(Cmp.string());
}

// Sorts a category's tags alphabetically (case-insensitive)
export function formatCategoryTags(tags: string[] | undefined): string | null {
    if (!tags?.length) {
        return null;
    }
    return [...tags].sort(Cmp.string()).join(", ");
}
